export default "__VITE_ASSET__COjDmN3J__"